function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageGeneratorComponent from '@/apps/audiences/components/ImageGeneratorComponent.vue';
import { mapState } from 'vuex';
import audiencias_service from '@/apps/audiences/services/audiencias_service';
export default {
  name: 'GenerativeImage',
  components: {
    ImageGeneratorComponent: ImageGeneratorComponent
  },
  data: function data() {
    return {
      // custom_audience_id: null,
      info: {},
      list_to_paginate: [],
      list_images: [],
      list_images_new: [],
      // ojo
      image: {
        description: ''
      },
      pagination: {
        current: 1,
        total: 0,
        limit: 12
      },
      // ojo
      size_page: 8,
      key_images: {},
      is_audience: false
    };
  },
  computed: _objectSpread({}, mapState('data-platform', ['companyCode', 'orgs'])),
  watch: {},
  created: function created() {
    this.image.description = 'Example';
    this.info.id = window.userInfo.email;
    this.getListImages(this.info.id);
  },
  mounted: function mounted() {},
  methods: {
    // getAudienceById() {
    //   audiencias_service.getAudienceById({ custom_audience_id: this.custom_audience_id })
    //     .then(response => {
    //       if (response.status) {
    //         this.audience = response.data
    //         console.log('this.audience')
    //         console.log(this.audience)
    //         this.audience.custom_audience_description = response.data.custom_audience_description
    //         this.audience.segment_name = response.data.segment_name
    //         this.audience.segment_size = response.data.segment_size
    //         this.audience.segment_code = response.data.segment_code
    //         this.estados = response.data.estados
    //         this.key_table += 1
    //         this.image.description = '' + this.audience.custom_audience_description
    //         this.getListImages(response.data.id)
    //       }
    //     })
    // },
    getListImages: function getListImages(user_id) {
      var _this = this;
      this.list_images = [];
      this.list_to_paginate = [];
      audiencias_service.getListImages(user_id, 0).then(function (response) {
        response.data.forEach(function (x) {
          x.details.forEach(function (img) {
            var item = _objectSpread({
              description: x.description,
              id_audience: x.id_audience,
              creation_user: x.creation_user,
              creation_date: x.creation_date
            }, img);
            _this.key_images[item.id] = item.id + '_' + 1;
            // if (this.audience_images[item.filename_storage]) {
            item.src = audiencias_service.getBaseUrl() + '/audience-images/image-view/' + item.filename_storage;
            item.type = '64';
            item.download = true;
            item.state = 2;
            _this.key_images[item.id] = item.id + '_' + 1;
            // }
            // this.list_images.push(item)
            _this.list_to_paginate.push(item);
          });
        });
        _this.nexChildtImages();
        // this.onViewOthers(0)
        _this.pagination.total = response.data.length;
      });
    },
    nexChildtImages: function nexChildtImages() {
      if (this.list_images.length >= this.list_to_paginate.length) {
        return;
      }
      var from = this.list_images.length;
      var nextSize = this.list_to_paginate.length - this.list_images.length;
      nextSize = nextSize > this.size_page ? this.size_page : nextSize;
      var to = from + nextSize;
      for (var i = from; i < to; i++) {
        this.list_images.push(this.list_to_paginate[i]);
        this.list_images_new.push(this.list_to_paginate[i]);
      }
    }
  }
};